import Model from './Model'

export default class Mailsequence extends Model {
    resource() {
        return 'mailsequence'
    }
    
}
